import { H5P } from 'h5p-standalone';
import 'expose-loader?h5pFrame!h5p-standalone/dist/frame.bundle';

const el = document.getElementById('h5p-container');

const displayOptions = { // Customise the look of the H5P
    frame: false,
    copyright: false,
    embed: false,
    download: false,
    icon: false,
    export: false
  };

const librariesPath = "/path/to/shared/libaries"; // Optional path to h5p activity libraries outside of content directory

if (el) {

  const h5pLocation = el.dataset.url;

  const options = {
    // id: 'lesson-one', // Optional unique ID, by default will be randomly generated
    frameJs: el.dataset.path + 'frame.bundle.js',
    frameCss: el.dataset.path + 'styles/h5p.css'
  };

  const h5p = new H5P(el, h5pLocation, options, displayOptions, librariesPath);

  // Jitter sollution, it happens because of iframe body scroll
  // either this or a fork with overflow: hidden on html.h5p-frame
  // this does not allow for page resize after render
  const resizeIframe = (e) => {
    console.log('resize iframe')
    let height = document.querySelector('.js-h5p-container iframe').contentWindow.innerHeight;
    document.querySelector('.js-h5p-container').style.margin = '0 auto';
    document.querySelector('.js-h5p-container').style.maxWidth =  (height*1.7777)-64+'px';
  }

  h5p.then(() => {
    document.querySelector('.js-h5p-container iframe').onload = function() {

      document.querySelector('.js-h5p-loader').remove();
      document.querySelector('.js-h5p-container').classList.remove('hide');
      this.contentWindow.addEventListener('resize', resizeIframe);

      setTimeout(function() {
        resizeIframe();
      }, 100)
    };
  });

}